module.exports = __webpack_public_path__ + "static/media/tabla.7a00b600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/tabla.svg
// module id = 167
// module chunks = 0